import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging, onMessage } from 'firebase/messaging';
import { registerServiceWorker } from '../lib/serviceWorker';

let serviceWorkerRegistration: ServiceWorkerRegistration | null = null;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

console.log('[Firebase] Initializing with config:', firebaseConfig);

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
auth.tenantId = import.meta.env.VITE_TENANT_ID;

export const messaging = getMessaging(app);

export async function initializeFirebase(): Promise<void> {
  try {
    serviceWorkerRegistration = await registerServiceWorker();
    if (!serviceWorkerRegistration) {
      console.error('[Firebase] Failed to register service worker');
    }
  } catch (error) {
    console.error('[Firebase] Service worker registration error:', error);
  }

  // Add foreground message handler
  if ('Notification' in window) {
    onMessage(messaging, async (payload) => {
      console.log('[Firebase] Received foreground message:', payload);
      console.log('[Firebase] Full payload:', JSON.stringify(payload, null, 2));

      try {
        if (Notification.permission !== 'granted') {
          console.warn('[Firebase] Notification permission not granted');
          return;
        }

        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) {
          console.error('[Firebase] No service worker registration found');
          return;
        }

        // Extract notification data with better validation
        const notificationData = {
          title: payload.notification?.title || 'New Message',
          body: payload.notification?.body || '',
          icon: '/logos/brandmark-sage-bg.png',
          badge: '/logos/brandmark-sage-bg.png',
          tag: payload.data?.chatRoomId || 'default',
          data: {
            ...payload.data,
            messageId: payload.messageId,
            timestamp: Date.now(),
            url: payload.data?.url || '/'
          },
          requireInteraction: true,
          actions: [
            {
              action: 'open',
              title: 'Open'
            }
          ]
        };

        console.log('[Firebase] Registration:', registration);
        console.log('[Firebase] Showing notification with data:', notificationData);
        await registration.showNotification(notificationData.title, notificationData);
        console.log('[Firebase] Notification displayed successfully');

        // Add click handler for foreground notifications
        // TODO: This is never triggered because showNotification() is a no-op in the foreground
        registration.addEventListener('notificationclick', (event) => {
          console.log('[Firebase] Notification clicked:', event);
          // @ts-ignore
          event.notification.close();

          // Handle notification click
          // @ts-ignore
          const url = event.notification.data?.url || '/';
          window.focus();
          window.location.href = url;
        });

      } catch (error) {
        console.error('[Firebase] Error showing notification:', error);
        console.error('[Firebase] Error details:', error instanceof Error ? error.message : String(error));
      }
    });
  }
}
